import styled, { css } from 'styled-components'

const Container = styled.div`
  background: ${props => props.theme.cores.branco};
  padding: 10px;
  width: 50%;
  align-items: center;
  display: flex;
  justify-content: center;
  border: 1px solid ${props => props.theme.cores.cinza200}; 
  border-radius: 3px;
  margin: 15px 0;
  cursor: pointer;

  ${props => ( props.isSelected ) ? css`
    border-bottom: 2px solid ${props.theme.cores[ props.color ]};
    ` : css`
    opacity: 0.7;
  `}

  > svg {
    max-height: 32px;   
  }
  
  > span {
    display: none;        
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    max-width: 345px;
    padding: 18px 30px;

    > span {
      align-self: center;
      display: block;
      max-width: 165px;
      margin-left: 16px;
      user-select: none;
      line-height: 1;
      
    }
  }
  
`

export { Container }
